import { travelTypeObject } from '../../enumeration';
import { PATH_DASHBOARD } from '../../routes/paths';
import api from '../../services/api';

const EVisitorManagement = {
  title: { name: ['امور بانکی', 'امور بانکی'] },
  routes: PATH_DASHBOARD.visitorManagement,
  api: api.travelRegister,
  enum: {
    array: Object.values(travelTypeObject),
    object: travelTypeObject,
  },
};

export default EVisitorManagement;
